import { createSlice } from '@reduxjs/toolkit';
import { getApplication } from '../../../shared/redux/applicationSlice';
import { clearForm } from './formSlice';

const initialState = {
  consent: null,
  stamp: null,
  accepted: false,
};

const declarationSlice = createSlice({
  name: 'declaration',
  initialState,
  reducers: {
    storeDeclaration(state, action) {
      return action.payload;
    },
    clearDeclaration(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.declaration };
      });
  },
});

export const { storeDeclaration, clearDeclaration } = declarationSlice.actions;
export const declarationReducer = declarationSlice.reducer;
